import inventoryUpdateQuickview from './inventoryUpdate-quickview.html'

const quickviewHandler = require('../../../../../components/quickview/quickview-handler')
const dtHandler        = require('../../../../../components/dt/dt-handler')
const formats          = require('../../../../../js-handler/math')

/****************ELEMENTS*****************/
var htmlQf          = {}
var HTMLwasSelected = false

function HTMLselect(detail){

      quickviewHandler.HTMLselect(
            'inventoryUpdate',
            'inventoryUpdate-quickview',
            detail.ev?.target,
            inventoryUpdateQuickview,
            htmlQf)

      HTMLwasSelected = true
}
/**/

export function start(detail){

      if(!HTMLwasSelected){ HTMLselect(detail) }

      obj[detail.act].start(detail)
}
/**/

const obj = {

      show: { start: (detail)=>{ show(detail)                           }},
      hide: { start: (detail)=>{ quickviewHandler.hide(detail, htmlQf) }},
}
/**/

function show(detail){

      const confirmUpdate = detail.id === 'confirmUpdate'
      const title         = htmlQf.quickviewHTML.querySelector('#inventoryUpdate-quickview-title')
      const message       = htmlQf.quickviewHTML.querySelector('#inventoryUpdate-quickview-message')
      const errorActions  = htmlQf.quickviewHTML.querySelector('#inventoryUpdate-quickview-error-actions')
      const confirmActions = htmlQf.quickviewHTML.querySelector('#inventoryUpdate-quickview-confirm-actions')

      title.textContent = confirmUpdate ? 'Update Inventory' : 'Inventory Error'
      message.textContent = confirmUpdate
            ? confirmUpdateDescription(detail.lines)
            : 'Enter a quantity equal to or lower than the available inventory. Only losses can be recorded.'

      errorActions.classList.toggle('dn', confirmUpdate)
      confirmActions.classList.toggle('dn', !confirmUpdate)

      confirmUpdate
            ? fillUpdateTable(detail.lines)
            : fillQuantityErrorTable(detail.lines)

      quickviewHandler.show(detail, htmlQf)
}

function fillQuantityErrorTable(lines){

      const data = lines.map((line)=>{
            return {
                  purchase_code: escapeHTML(line.purchase_code),
                  item:          escapeHTML(line.item),
                  unit:          escapeHTML(line.unit),
                  available_qty: line.available_qty,
                  entered_qty:   line.entered_qty,
            }
      })

      const columns = [
            {key: 'purchase_code', label: 'PO'},
            {key: 'item', label: 'Item'},
            {key: 'unit', label: 'Unit'},
            {key: 'available_qty', label: 'Available Qty', format: 'int'},
            {key: 'entered_qty', label: 'Entered Qty', format: 'int'},
      ]

      const container = document.createElement('div')
      container.innerHTML = dtHandler.dtSimpleFc(data, columns)

      container.querySelectorAll('tbody tr').forEach((row)=>{
            const enteredQty = row.querySelectorAll('.value-text')[4]

            highlightValue(enteredQty)
      })

      const table = htmlQf.quickviewHTML.querySelector('#inventoryUpdate-quickview-table')
      table.innerHTML = container.innerHTML
}

function fillUpdateTable(lines){

      const data = lines.map((line)=>{
            const lossQty             = Number(line.available_qty) - Number(line.qty)
            const sellingPrice        = Number(line.selling_price)
            const sellingPriceChanged = sellingPrice !== Number(line.original_selling_price)

            return {
                  purchase_code: escapeHTML(line.purchase_code),
                  item:          escapeHTML(line.item),
                  unit:          escapeHTML(line.unit),
                  loss_qty:      lossQty > 0 ? lossQty : '-',
                  selling_price: sellingPriceChanged ? formats.cashFormat(sellingPrice, true) : '-',
            }
      })

      const columns = [
            {key: 'purchase_code', label: 'PO'},
            {key: 'item', label: 'Item'},
            {key: 'unit', label: 'Unit'},
            {key: 'loss_qty', label: 'Loss Qty'},
            {key: 'selling_price', label: 'Selling Price'},
      ]

      const container = document.createElement('div')
      container.innerHTML = dtHandler.dtSimpleFc(data, columns)

      const rows = container.querySelectorAll('tbody tr')

      rows.forEach((row, index)=>{
            const values = row.querySelectorAll('.value-text')
            const line   = lines[index]

            if(data[index].loss_qty !== '-'){
                  highlightValue(values[3])
            }

            if(Number(line.selling_price) !== Number(line.original_selling_price)){
                  highlightValue(values[4])
            }
      })

      const table = htmlQf.quickviewHTML.querySelector('#inventoryUpdate-quickview-table')
      table.innerHTML = container.innerHTML
}

function confirmUpdateDescription(lines){

      const hasLoss = lines.some((line)=>{
            return Number(line.available_qty) > Number(line.qty)
      })
      const hasSellingPrice = lines.some((line)=>{
            return Number(line.selling_price) !== Number(line.original_selling_price)
      })

      if(hasLoss && hasSellingPrice){
            return 'Are you sure you want to report these losses and update these selling prices below?'
      }

      if(hasSellingPrice){
            return 'Are you sure you want to update these selling prices below?'
      }

      return 'Are you sure you want to report these losses below?'
}

function highlightValue(value){

      value.classList.add('font-red')
      value.style.color = '#b00020'
      value.style.fontWeight = '700'
}

function escapeHTML(value){

      return `${value ?? ''}`
            .replaceAll('&', '&amp;')
            .replaceAll('<', '&lt;')
            .replaceAll('>', '&gt;')
            .replaceAll('"', '&quot;')
            .replaceAll("'", '&#039;')
}
